export default class Course{
	constructor(){
		this.name = "Cedar Creek Country Club";
		this.holes = [
			{"number":1,"par":4, "yardage": 385,"handicap":4},
			{"number":2,"par":5, "yardage": 515,"handicap":16},
			{"number":3,"par":3, "yardage": 162,"handicap":12},
			{"number":4,"par":4, "yardage": 318,"handicap":8},
			{"number":5,"par":4, "yardage": 401,"handicap":2},
			{"number":6,"par":5, "yardage": 502,"handicap":18},
			{"number":7,"par":3, "yardage": 133,"handicap":14},
			{"number":8,"par":4, "yardage": 368,"handicap":6},
			{"number":9,"par":4, "yardage": 404,"handicap":10},
			{"number":10,"par":4,"yardage": 407,"handicap":7},
			{"number":11,"par":3,"yardage": 200,"handicap":9},
			{"number":12,"par":5,"yardage": 511,"handicap":11},
			{"number":13,"par":4,"yardage": 348,"handicap":13},
			{"number":14,"par":3,"yardage": 132,"handicap":17},
			{"number":15,"par":4,"yardage": 412,"handicap":1},
			{"number":16,"par":3,"yardage": 172,"handicap":5},
			{"number":17,"par":5,"yardage": 535,"handicap":15},
			{"number":18,"par":4,"yardage": 391,"handicap":3}
		],
		this.parOut = 36;
		this.parIn = 35;
		this.parTotal = 71;
		this.rating = 70.5;
		this.slope = 127;
	}
	get parArray() {
		return this.holes.map(hole => hole.par)
	}
	get front() {
		return this.holes.slice(0,9)
	}
	get back() {
		return this.holes.slice(9,18)
	}
}

